// Get Batch Message Templates
export const GET_BATCH_MESSAGE_TEMPLATES_REQUEST = 'GET_BATCH_MESSAGE_TEMPLATES_REQUEST';
export const GET_BATCH_MESSAGE_TEMPLATES_DONE = 'GET_BATCH_MESSAGE_TEMPLATES_DONE';
export const GET_BATCH_MESSAGE_TEMPLATES_FAILED = 'GET_BATCH_MESSAGE_TEMPLATES_FAILED';
export const GET_BATCH_MESSAGE_TEMPLATES_RESET = 'GET_BATCH_MESSAGE_TEMPLATES_RESET';

// Operations
export const BATCH_MESSAGE_TEMPLATES_SET_PAGE = 'BATCH_MESSAGE_TEMPLATES_SET_PAGE';